import React from 'react';

export default props => (
  <svg {...props} viewBox="0 0 150 150">
    {props.children}
    <path
      fill="none"
      stroke="#000"
      strokeLinejoin="round"
      strokeWidth={0.5}
      d="m36 112.8 7.5-4.2-8.4-4.2-7.4 4.2 8.4 4.2Zm10.8-5.5 16.5-9.4-8.6-4.5-16.6 9.4 8.7 4.5Z"
    />
    <path
      fill="none"
      stroke="#000"
      strokeDasharray="0 0 6.77 6.77"
      strokeLinejoin="round"
      strokeWidth={0.5}
      d="m3 109.6 71-42.8 73 40.1-70.8 42.8-73-40Z"
    />
    <path fill="#fff" d="m46.7 127.8 62-35.7.1-77.2L93 0 46.7 26.8v101Z" />
    <path d="m70.5 25 15.2-9.4v.5l-15.2 9.4V25Zm0 15.9 15.2-9.4v.5l-15.2 9.4v-.5Zm0 7.9 15.2-9.3v.5l-15.2 9.4v-.6ZM55.4 80.4l30-18.4v.5l-30 18.4v-.5Zm0-7.4 30-18.4v.5l-30 18.4V73Zm0-7.4 30-18.5v.6L55.5 66v-.5Zm15.4-32.8 14.9-9.3v.6l-15 9.2v-.5Z" />
    <path
      fill="#FAF5EF"
      stroke="#000"
      strokeLinejoin="round"
      strokeWidth={0.5}
      d="M66.7 51.6 55 58.2V34l11.6-6.6v24.3Zm34.8 2L92 59.3V34.9l9.5-5.7v24.4Z"
    />
    <path fill="#FAF5EF" d="M91 26.8V1.2L93 0l16 14.9V16L91 26.8Z" />
    <path
      fill="#fff"
      stroke="#000"
      strokeLinejoin="round"
      strokeWidth={0.5}
      d="m93 0 16 14.9-16 9.3V0Zm2 66.5-3.3-1.8v24.2l3.3 1.9V66.5Z"
    />
    <path
      fill="#FAF5EF"
      stroke="#000"
      strokeLinejoin="round"
      strokeWidth={0.5}
      d="m95 66.5 7.4-4.2v24.2L95 90.8V66.5Z"
    />
    <path fill="#fff" stroke="#000" strokeLinejoin="round" strokeWidth={0.5} d="m83 84.2-3.2-2v14.3l3.2 1.9V84.2Z" />
    <path
      fill="#FAF5EF"
      stroke="#000"
      strokeLinejoin="round"
      strokeWidth={0.5}
      d="m83 84.2 7.4-4.3v14.2L83 98.4V84.2Z"
    />
    <path fill="#fff" stroke="#000" strokeLinejoin="round" strokeWidth={0.5} d="m71 87.7-3.3-2v18.6l3.3 1.9V87.7Z" />
    <path
      fill="#FAF5EF"
      stroke="#000"
      strokeLinejoin="round"
      strokeWidth={0.5}
      d="m71 87.7 7.3-4.3V102l-7.3 4.3V87.7Z"
    />
    <path
      fill="#fff"
      stroke="#000"
      strokeLinejoin="round"
      strokeWidth={0.5}
      d="m75 81.5 3.3 1.9-7.3 4.3-3.3-1.9 7.3-4.3zM87.1 78l3.3 1.9-7.4 4.3-3.3-1.9 7.4-4.3zm12-17.6 3.3 1.9-7.4 4.2-3.3-1.9 7.4-4.2zM63 97.6l3.2 1.9-7.3 4.2-3.3-1.9 7.4-4.2zm-4.1 6.1-3.3-1.9v10.4l3.3 1.9v-10.4z"
    />
    <path
      fill="#FAF5EF"
      stroke="#000"
      strokeLinejoin="round"
      strokeWidth={0.5}
      d="m58.9 103.7 7.3-4.2v10.4l-7.3 4.2v-10.4zm56.3-1-7.4 4.2 8.3 4.2 7.5-4.2-8.4-4.2Z"
    />
    <path
      fill="none"
      stroke="#000"
      strokeLinejoin="round"
      strokeWidth={0.5}
      d="M104.5 108.2 88 117.6l8.6 4.5 16.6-9.4-8.7-4.5Zm-15.4 14-16.6 9.9m-25.8-4.3 62-35.7.1-77.2L93 0 46.7 26.8v101Z"
    />
  </svg>
);
